import { LABELS } from 'constants/Analytics'
import * as C from 'constants/Redux'

export const { OUTGOING } = LABELS

const PREFIX = 'ANALYTICS / '
const OUTGOING_CALL_SOURCE = `${PREFIX}OUTGOING_CALL_SOURCE`

export const OUTGOING_CALL_SOURCE_SET = OUTGOING_CALL_SOURCE + C.SET
export const OUTGOING_CALL_SOURCE_CLEAR = OUTGOING_CALL_SOURCE + C.CLEAR

export const INITIAL_STATE = {
  outgoingCallSource: OUTGOING.UNKNOWN,
}
